export enum EPanelId {
	Habits,
	Dreams,
	Calendar,
	Workflows,
	LogMonumental,
	LifeChangingEvents,
	Hero,
	Weather,
	UnderDevelopment
}
